module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "map-page",
    attrs: {
      "id": "chart-map-pre"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "map-btn"
  }, [_c('a', {
    staticClass: "btn-1",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.changeColor
    }
  }, [_vm._v("显示地名")]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "btn-3",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.initBMap
    }
  }, [_vm._v(" 初 始 化 ")])]), _vm._v(" "), (_vm.preStatus > 0) ? _c('div', {
    staticClass: "map-select-station"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "选择油库"
    },
    model: {
      value: (_vm.activeStation),
      callback: function($$v) {
        _vm.activeStation = $$v
      },
      expression: "activeStation"
    }
  }, _vm._l((_vm.stationLocationList), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }))], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e34e8970"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/map_pre.vue
// module id = 816
// module chunks = 1